import axios from 'axios';
import { getAuthToken, setAuthToken } from './authUtils';
import config from '../config';

const mentorApiService = axios.create({
  baseURL: config.apiUrl, 
});

mentorApiService.interceptors.request.use(
  (config) => {
    const authToken = getAuthToken('mentor');
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

mentorApiService.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // localStorage.removeItem('mtoken');
      // window.location.href = '/mentor';
      console.error('Authentication error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default mentorApiService;
